import { ReactNode } from "react";
import { useAppDispatch, useAppSelector } from "../redux/hooks/hooks";
import { Navigate, useLocation } from "react-router-dom";
import { VerifyToken } from "@/utils/verifyToken";
import { TUser } from "@/types/types";
import { logOut } from "@/redux/feature/auth/authSlice";

const ProtectedRoute = ({ children }: { children: ReactNode }) => {
  // const { token } = useAppSelector((state) => state.auth);

  const { token, user: authUser } = useAppSelector((state) => state.auth);
  const location = useLocation();
  // console.log("token", token);
  const dispatch = useAppDispatch();
  const role = "creator";
  let user;
  // console.log("inituser", user);
  if (token) {
    // console.log("token", token);
    user = VerifyToken(token);
  }
  // console.log("role", role);
  // console.log("user", user);

  if (role !== undefined && (user as TUser)?.role !== role) {
    // Store both pathname and query params (search)
    // console.log("logging out for role miss match");
    dispatch(logOut());
    const redirectTo = location.pathname + location.search;
    return (
      <Navigate
        replace
        to={`/auth/sign-in?redirect=${encodeURIComponent(redirectTo)}`}
      />
    );
  }

  // 🧩 Case 2: No token — not logged in
  if (!token) {
    const redirect = encodeURIComponent(location.pathname + location.search);
    return <Navigate replace to={`/auth/sign-in?redirect=${redirect}`} />;
  }
  // if (!token) {
  //   return <Navigate to={"/auth/sign-up"} replace={true} />;
  // }
  return <>{children}</>;
};

export default ProtectedRoute;
